import { render, staticRenderFns } from "./campaignEdit.vue?vue&type=template&id=20279e4e&"
import script from "./campaignEdit.vue?vue&type=script&lang=js&"
export * from "./campaignEdit.vue?vue&type=script&lang=js&"
import style0 from "./campaignEdit.vue?vue&type=style&index=0&id=20279e4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports